import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dayPanel", "dateLabel", "prevBtn", "nextBtn"]

  connect() {
    this.currentIndex = this.findInitialIndex()
    this.showDay(this.currentIndex)
  }

  prevDay() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.showDay(this.currentIndex)
    }
  }

  nextDay() {
    if (this.currentIndex < this.dayPanelTargets.length - 1) {
      this.currentIndex++
      this.showDay(this.currentIndex)
    }
  }

  showDay(index) {
    this.dayPanelTargets.forEach((panel, i) => {
      panel.classList.toggle("d-none", i !== index)
    })
    this.dateLabelTarget.textContent = this.dayPanelTargets[index].dataset.dateLabel
    this.updateNavButtons()
  }

  updateNavButtons() {
    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.disabled = this.currentIndex === 0
    }
    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.disabled = this.currentIndex === this.dayPanelTargets.length - 1
    }
  }

  findInitialIndex() {
    const index = this.dayPanelTargets.findIndex(
      (p) => !p.classList.contains("d-none")
    )
    return index >= 0 ? index : 0
  }
}
